<template>
    <div class="layout">
        <Layout class="layouts">
            <Sider hide-trigger :style="{height:($store.state.tableHight - 65) + 'px'}" class="rx-sider">
                <Side></Side>
            </Sider>
            <Layout>
                <headers></headers>
                <Content class="em-body" :style="{height:($store.state.tableHight - 65) + 'px'}">
                    <Row>
                        <Col span="24">
                            <div class="em-list-header">
                                <div class="em-list-header-search">
                                    <Input class="search-input" size="small" clearable v-model="search.name" placeholder="编号" />
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.project_id"  clearable filterable  placeholder="项目">
                                        <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}<small>{{item.status_name}}</small></Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small"  v-model="search.customer_id"  clearable filterable  placeholder="客户">
                                        <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.type_id" clearable
                                            filterable placeholder="收入类型">
                                        <Option :value="item.id" v-for="(item,index) in typeList" :key="index">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.other_id" clearable
                                            filterable placeholder="其他">
                                        <Option :value="1">计划收款</Option>
                                        <Option :value="2">非计划收款</Option>
                                        <Option :value="3">需要发票</Option>
                                        <Option :value="4">无需发票</Option>
                                        <Option :value="5">待开发票</Option>
                                        <Option :value="6">未全额开票</Option>
                                        <Option :value="7">已开票</Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select class="search-select" size="small" v-model="search.apply_id" clearable
                                            filterable placeholder="申请人">
                                        <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">
                                            {{ item.real_name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Select size="small" v-model="search.status" clearable placeholder="状态"
                                            class="search-select">
                                        <Option :value="item.id" v-for="(item,index) in statusList" :key="index">
                                            {{ item.name }}
                                        </Option>
                                    </Select>
                                    &nbsp;&nbsp;
                                    <Button size="small" @click="onSearch"><Icon type="ios-search" /> 搜索</Button>
                                </div>
                                <div class="rx-list-header-btn">
                                    <ButtonGroup >
                                        <Button type="primary" size="small" class="text-font-sm" @click="createData"><Icon type="md-add" /> 创建收入</Button>
                                        <Button type="warning" size="small" class="text-font-sm" @click="reSet"><Icon type="md-refresh" /> 刷新</Button>
                                        <Button v-if="$store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2" type="success" size="small" class="text-font-sm" @click="exportData"><Icon type="md-paper-plane" /> 导出数据</Button>
                                    </ButtonGroup>
                                </div>
                            </div>

                        </Col>
                    </Row>
                    <Row>
                        <Col span="24">
                            <Table row-key="id" ref="selection" stripe border :loading="$store.state.loading" :columns="columns" :data="dataList.data" no-data-text="暂无数据记录">
                                <template #sn="{ row }">
                                    <div class="d-width cursor text-primary" :title="row.sn" @click="showData(row.id)">
                                        <span>{{row.sn}}</span>
                                    </div>
                                </template>
                                <template #money="{ row }">
                                    <span>{{row.money}}</span>
                                </template>
                                <template #tax_rate="{ row }">
                                    <span>{{row.tax_rate}} %</span>
                                </template>
                                <template #true_money="{ row }">
                                    <span class="text-success">{{row.true_money}}</span>
                                </template>
                                <template #type_id="{ row }">
                                    <Tag v-if="row.type_id === 1" color="blue">{{row.type_name}}</Tag>
                                    <Tag v-else-if="row.type_id === 2" color="orange">{{row.type_name}}</Tag>
                                    <Tag v-else-if="row.type_id === 3" color="green">{{row.type_name}}</Tag>
                                    <Tag v-else-if="row.type_id === 4" color="purple">{{row.type_name}}</Tag>
                                    <span v-else>-</span>
                                </template>
                                <template #is_plan="{ row }">
                                    <Tag v-if="row.is_plan === 1" :color="row.plan_day <=0 && row.status !== 4 ?'red':'default'">{{row.plan_time}}</Tag>
                                    <span v-else>-</span>
                                </template>
                                <template #status="{ row }">
                                    <Badge v-if="row.status === 1" color="blue" :text="row.status_name" />
                                    <Badge v-else-if="row.status === 2" color="orange" :text="row.status_name" />
                                    <Poptip v-else-if="row.status === 4" trigger="hover" width="240" :word-wrap="true" title="到账信息：" >
                                        <Badge color="green" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">金额：<span class="text-success">{{row.get_money}}</span></p>
                                            <p style="white-space: normal;">时间：{{row.get_date}}</p>
                                        </template>
                                    </Poptip>
                                    <Poptip v-else-if="row.status === 3" trigger="hover" width="240" :word-wrap="true" title="驳回原因：" >
                                        <Badge color="red" :text="row.status_name" />
                                        <template #content>
                                            <p style="white-space: normal;">时间：{{row.reject_time}}</p>
                                            <p style="white-space: normal;">原因：<span class="text-danger">{{row.reject_remark}}</span></p>
                                        </template>
                                    </Poptip>
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #is_invoice="{ row }">
                                    <Badge v-if="row.is_invoice === 1" color="#999" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 2" color="blue" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 3" color="orange" :text="row.is_invoice_name" />
                                    <Badge v-else-if="row.is_invoice === 4" color="green" :text="row.is_invoice_name" />
                                    <Badge v-else color="#999999" text="其他" />
                                </template>
                                <template #apply_id="{ row }">
                                    <div class="d-width" :title="row.apply_name">
                                        <span>{{row.apply_name}}</span>
                                    </div>
                                </template>
                                <template #project_id="{ row }">
                                    <div class="d-width" :title="row.project_name">
                                        <span>{{row.project_name}}</span>
                                    </div>
                                </template>
                                <template #customer_id="{ row }">
                                    <div class="d-width" :title="row.company">
                                        <span>{{row.company}}</span>
                                    </div>
                                </template>
                                <template #remark="{ row }">
                                    <div class="d-width" :title="row.remark">
                                        <span>{{row.remark ?? '-'}}</span>
                                    </div>
                                </template>
                                <template #action="{ row, index }">
                                    <a class="text-font-sm text-orange" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) " @click="examineData(row.id, row.project_name)">{{row.status === 2 ? '重审':'审批'}}</a>
                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.status === 1 || row.status === 2) "/>
<!--                                    <a class="text-font-sm text-violet" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.is_invoice === 2 || row.is_invoice === 3)" @click="invoiceData(row.id, row.project_name)">开票</a>-->
<!--                                    <Divider type="vertical" v-if="($store.state.userinfo.group_id === 1 || $store.state.userinfo.group_id === 2 || $store.state.userinfo.group_id === 3) && (row.is_invoice === 2 || row.is_invoice === 3)"/>-->
                                    <a class="text-font-sm text-primary" @click="editData(row.id)" v-if="row.status !== 4">编辑</a>
                                    <Divider type="vertical" v-if="row.status !== 4"/>
                                    <a class="text-font-sm text-danger" v-if="row.status !== 4" @click="deleteData(row.id, index)">删除</a>
                                    <a class="text-font-sm text-success" v-if="row.status === 4" @click="showData(row.id)">查看</a>
                                </template>
                            </Table>
                            <div class="em-page em-flex">
                                <Page size="small" :total="dataList.total" :current="page" :page-size="pageSize" show-total @on-change="changePage" />
                            </div>
                        </Col>
                    </Row>

                    <!-- 创建/编辑  -->
                    <add-modal v-if="is_create" ref="AddRef" @trueHandler="saveData"></add-modal>

                    <!-- 财务入账审批  -->
                    <examine-modal v-if="is_income_examine" ref="ExamineIncomeRef" @trueHandler="saveData"></examine-modal>

                    <!-- 开发票  -->
                    <invoice-modal v-if="is_income_invoice" ref="InvoiceIncomeRef" @trueHandler="saveData"></invoice-modal>

                    <!-- 收款详情  -->
                    <show-income-modal v-if="is_show" ref="ShowIncomeRef"></show-income-modal>

                    <Modal
                        v-model="is_export"
                        title="导出数据"
                        @on-ok="onExport"
                        :loading="export_loading"
                        width="800px"
                        ok-text="立即导出"
                        @on-cancel="cancelExport">
                        <Row :gutter="32">
                            <Col :span="24">
                                <Form ref="SearchForms" :model="SearchForms" :rules="SearchRules"  label-position="left">
                                    <Row :gutter="32">
                                        <Col :span="24">
                                            <FormItem label="项目" prop="project_id">
                                                <Select class="search-select"  v-model="SearchForms.project_id"  clearable filterable  placeholder="选择项目">
                                                    <Option :value="item.project_id" v-for="(item,index) in projectList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="客户" prop="customer_id">
                                                <Select class="search-select" v-model="SearchForms.customer_id"  clearable filterable  placeholder="选择客户">
                                                    <Option :value="item.id" v-for="(item,index) in customerList" :key="index">{{item.company}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="收入类型" prop="type_id">
                                                <Select class="search-select"   v-model="SearchForms.type_id"  clearable filterable  placeholder="选择收入类型">
                                                    <Option :value="item.id" v-for="(item,index) in typeList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="其他" prop="other_id">
                                                <Select class="search-select" v-model="SearchForms.other_id"  clearable filterable  placeholder="其他">
                                                    <Option :value="1">计划收款</Option>
                                                    <Option :value="2">非计划收款</Option>
                                                    <Option :value="3">需要发票</Option>
                                                    <Option :value="4">无需发票</Option>
                                                    <Option :value="5">待开发票</Option>
                                                    <Option :value="6">未全额开票</Option>
                                                    <Option :value="7">已开票</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请人" prop="apply_id">
                                                <Select class="search-select"   v-model="SearchForms.apply_id"  clearable filterable  placeholder="选择申请人">
                                                    <Option :value="item.admin_id" v-for="(item,index) in userList" :key="index">{{item.real_name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="状态" prop="status">
                                                <Select class="search-select"   v-model="SearchForms.status"  clearable filterable  placeholder="选择状态">
                                                    <Option :value="item.id" v-for="(item,index) in statusList" :key="index">{{item.name}}</Option>
                                                </Select>
                                            </FormItem>
                                        </Col>
                                        <Col :span="12">
                                            <FormItem label="申请日期" prop="time">
                                                <DatePicker class="width-100" v-model="SearchForms.time" clearable type="daterange" format="yyyy-MM-dd"  placeholder="选择日期" />
                                            </FormItem>
                                        </Col>
                                    </Row>
                                </Form>
                            </Col>
                        </Row>
                    </Modal>

                </Content>
            </Layout>
        </Layout>
    </div>
</template>

<script>
import '@/assets/style.css'
import Headers from "@/components/public/Headers";
import Side from "@/components/public/Side";
import AddModal from "../Create";
import ExamineModal from "../Examine";
import InvoiceModal from "../Invoice";
import ShowIncomeModal from "../Show";
import {deleteIncome, exportIncome, getIncomeConfig, getIncomeList} from "@/apis/income";
export default {
    name: "IncomeIndex",
    components: {
        Headers, Side, AddModal, ExamineModal, InvoiceModal, ShowIncomeModal
    },
    data () {
        return {
            projectList: [],
            customerList: [],
            typeList: [],
            userList: [],
            statusList: [],

            search: {
                name: '',
                project_id: '',
                customer_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: ''
            },
            page : 1,
            pageSize : 15,
            selectCount  : 0,
            dataList : [],
            columns: [
                {
                    title: '编号',
                    key: 'sn',
                    slot: 'sn',
                    fixed:'left',
                    width : 160
                },
                {
                    title: '金额',
                    key: 'money',
                    slot: 'money',
                    width: 120
                },
                {
                    title: '费率',
                    key: 'tax_rate',
                    slot: 'tax_rate',
                    width: 100
                },
                {
                    title: '税费',
                    key: 'tax_money',
                    width: 120
                },
                {
                    title: '实收',
                    key: 'true_money',
                    slot: 'true_money',
                    width: 120
                },
                {
                    title: '类型',
                    key: 'type_id',
                    slot: 'type_id',
                    width: 100
                },
                {
                    title: '计划收款',
                    key: 'is_plan',
                    slot: 'is_plan',
                    width: 120
                },
                {
                    title: '状态',
                    key: 'status',
                    slot: 'status',
                    width: 100
                },
                {
                    title: '发票',
                    key: 'is_invoice',
                    slot: 'is_invoice',
                    width: 120
                },
                {
                    title: '申请人',
                    key: 'apply_id',
                    slot: 'apply_id',
                    width: 100
                },
                {
                    title: '项目',
                    key: 'project_id',
                    slot: 'project_id',
                    minWidth:120
                },
                {
                    title: '客户',
                    key: 'customer_id',
                    slot: 'customer_id',
                    minWidth:120
                },
                {
                    title: '备注',
                    key: 'remark',
                    slot: 'remark',
                    minWidth:120
                },
                {
                    title: '',
                    key: 'action',
                    slot : 'action',
                    // align: 'center',
                    fixed : 'right',
                    width : 150
                }
            ],
            is_create : false,
            is_income_examine : false,
            is_income_invoice : false,
            is_show : false,

            is_export : false,
            export_loading : true,
            SearchForms: {
                project_id: '',
                customer_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: '',
                time: []
            },
            SearchRules: {},
            site_url : this.$siteApi,

        }
    },
    created(){
        this.getConfig();
        this.getList();
    },
    mounted(){
        let that = this;
        that.HeightInit();
    },
    computed: {

    },
    methods: {
        exportData(){
            let that = this;
            that.is_export =  true;
        },
        onExport(){
            let that = this;
            exportIncome({search:that.SearchForms}).then( e =>{
                that.$Message.success({ background: true,duration:3, content:e.msg});
                if(e.data){
                    //下载文件
                    const fileUrl = that.site_url + e.data.url; // 文件的URL地址
                    const parts = fileUrl.split('/');
                    const fileName = parts[parts.length - 1];
                    const link = document.createElement('a');
                    link.href = fileUrl;
                    link.target = '_blank';
                    link.setAttribute('download', fileName);
                    link.click();
                }else{
                    that.$Message.error({ background: true,duration:3, content: '没有文件可下载'});
                }
                that.cancelExport();
            })
        },
        cancelExport(){
            let that = this;
            that.is_export =  false;
            that.SearchForms = {
                project_id: '',
                customer_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: '',
                time: []
            }
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        onSearch(){
            let that = this;
            that.page = 1;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 15:14
         **/
        reSet(){
            let that = this;
            that.page = 1;
            that.search = {
                name: '',
                project_id: '',
                customer_id: '',
                type_id: '',
                other_id: '',
                apply_id: '',
                status: ''
            };
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 14:05
         **/
        getConfig(){
            let that = this;
            getIncomeConfig().then(e=>{
                that.projectList = e.data.projectList ?? [];
                that.customerList = e.data.customerList ?? [];
                that.typeList = e.data.typeList ?? [];
                that.userList = e.data.userList ?? [];
                that.statusList = e.data.statusList ?? [];
            })
        },
        /**
         功能：列表
         time: 2025-09-01 18:09:28
         **/
        getList(){
            let that = this;
            const params = {
                pageSize : that.pageSize,
                page : that.page,
                search : that.search
            };
            that.$store.commit('SET_LOADING' , true);
            getIncomeList(params).then(e=>{
                that.dataList = e.data;
                that.selectCount = 0;
            })
        },
        /**
         功能：分页
         time: 2025-54-03 09:54:43
         **/
        changePage (e) {
            let that = this;
            that.page = e;
            that.getList();
        },

        /**
         功能：
         time: 2026/1/6 16:36
         **/
        createData(){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.add();
            })
        },
        /**
         功能：
         time: 2026/1/6 16:50
         **/
        editData(id){
            let that = this;
            that.is_create = true;
            setTimeout(function(){
                that.$refs.AddRef.edit(id);
            })
        },
        /**
         功能：
         time: 2026/1/6 17:11
         **/
        showData(id){
            let that = this;
            that.is_show = true;
            setTimeout(function(){
                that.$refs.ShowIncomeRef.show(id);
            })
        },

        /**
         功能：
         time: 2026/1/6 17:00
         **/
        examineData(id, project_name){
            let that = this;
            that.is_income_examine = true;
            setTimeout(function(){
                that.$refs.ExamineIncomeRef.show(id, project_name);
            })
        },
        /**
         功能：
         time: 2026/1/6 17:02
         **/
        invoiceData(id, project_name){
            let that = this;
            that.is_income_invoice = true;
            setTimeout(function(){
                that.$refs.InvoiceIncomeRef.add(id, project_name);
            })
        },

        /**
         功能：操作返回
         time: 2025-26-02 09:26:53
         **/
        saveData(){
            let that = this;
            that.getList();
        },
        /**
         功能：
         time: 2026/1/6 16:56
         **/
        deleteData(id, index){
            let that = this;
            if(!id){
                that.$Message.error({ background: true,duration:3, content:'记录不存在'});
                return;
            }
            that.$Modal.confirm({
                title: '删除记录',
                content: '此操作将删除记录不可恢复, 是否继续?',
                onOk: () => {
                    deleteIncome(id).then( e =>{
                        that.dataList.data.splice(index , 1);
                        that.$Message.success({ background: true,duration:3, content:e.msg});
                    })
                },
                onCancel: () => {}
            });
        },
        HeightInit(){
            this.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            // 动态计算 table 的高度重新赋值
            const that = this;
            window.onresize = function () {
                that.$store.commit('SET_TABLE_HEIGHT' , window.innerHeight);
            }
        }
    }
}
</script>

<style scoped lang="less" rel="stylesheet/less">

</style>
